<div class="d-flex main">
    <!-- Sidebar -->
    <app-sidebar />

    <!-- Main Content Area -->
    <div class="flex-grow-1 d-flex flex-column">
        <app-header />
        <div class="flex-grow-1 overflow-y-auto bg-back">
            <div class="container py-3 px-4">
                <app-breadcrumb></app-breadcrumb>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>